import { defineMessages } from 'react-intl';

export default defineMessages({
  title: 'Select preferred network',

  mainnet: '{network}',
  testNetwork: '{network} Test Network',
  forkNetwork: '{network} Fork Network',
});
